module.exports = __webpack_public_path__ + "img/ic_remote_work.ff63ca86.svg";